import { useAtom } from 'jotai'
import { Store } from 'lib/models'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'

const { atom, resetAtom } = createAtom<Store | undefined>(undefined, MMKVKey.CurrentStore)

export const useCurrentStoreAtom = () => useAtom(atom)
export const resetCurrentStoreAtom = () => useAtom(resetAtom)
